import React, {Component} from 'react';
import {connect} from 'react-redux';

import Box from 'components/box';
import Spinner from 'spinner';
import {RecordDetailList} from './record-detail-list';
import {DocumentList} from 'components/documents';

import {loadRecordDetail} from 'redux/actions/portal/records';

const mapStateToProps = state => ({record: state.records.get('recordDetail'), isFetching: state.records.get('isLoading')});

const mapDispatchToProps = dispatch => ({
	onLoad: (id) => dispatch(loadRecordDetail(id))
});

class RecordDetail extends Component {

	componentWillMount() {
		this.props.onLoad(this.props.match.params.record_id);
	}

	render() {

		if (this.props.isFetching) {
			return <Spinner/>
		}

		if (this.props.record === undefined || this.props.record.size === 0) {
			return <Spinner/>;
		}

		return (<div>
			<Box title3="Інформація про запис до лікаря">
				<RecordDetailList record={this.props.record}/>
			</Box>
			<Box title3="Відповідь реєстратури">
				<h4>
					{this.props.record.get('status') === 1 && "Ваша заявка підтверджена"}
					{this.props.record.get('status') === 2 && "Ваша заявка відхилена"}
					{this.props.record.get('status') === 0 && "Ваша заявка розглядається"}
				</h4>
				<DocumentList>
					{
						this.props.record.get('comment') && <li>Коментар до заявки:
								<strong> {this.props.record.get('comment')}</strong>
							</li>
					}
				</DocumentList>
			</Box>
		</div>)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(RecordDetail);



// WEBPACK FOOTER //
// ./src/cabinet/records/detail.js